import React from 'react';
import { Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { capitalize } from 'lodash';

import { buildIssueUrl, getCRMToken, trackViewRequestDetails } from '@private-crm-app/utils';
import { PrivateSubmissionAppRoutes } from '@private-crm-app/constants';

import './style.scss';

interface PrivateSubmissionInfoProps {
  submission: IPrivateCustomerSubmission;
  user: IContactResponse;
}

function getBackgroundColor(submissionStatus: CustomerSubmissionStatus): string {
  if (submissionStatus === CustomerSubmissionStatus.OPEN) {
    return '#99c6e1';
  }

  return '#d8d8d8';
}

export default function PrivateSubmissionInfo({ submission, user }: PrivateSubmissionInfoProps) {
  const ariaLabel = `View Request #${submission.submissionNumber}, Status: ${capitalize(submission.status)}${submission.category?.name ? `, Category: ${submission.category.name}` : ''}`;

  return (
    <li className="submission-listing__item">
      <Link
        to={
          submission.id
            ? buildIssueUrl(submission.id, getCRMToken())
            : PrivateSubmissionAppRoutes.ISSUE_BASE_PATH
        }
        onClick={() => {
          localStorage.setItem('submission', JSON.stringify(submission));
          trackViewRequestDetails(user?.name, user?.email);
        }}
        className="submission-listing__item-link"
        aria-label={ariaLabel}
      >
        <div className="submission-listing__item-header">
          <span className="submission-listing__item-id">Request #{submission.submissionNumber}</span>
          <span
            className={classnames('submission-listing__item-status', {
              'submission-listing__item-status--closed': submission.status === CustomerSubmissionStatus.CLOSED,
            })}
          >
            {capitalize(submission.status)}
          </span>
          <span className="line-break" />
          <span
            className="submission-listing__item-category"
            style={{ backgroundColor: getBackgroundColor(submission.status) }}
          >
            {submission.category?.name}
          </span>
        </div>
        <div className="submission-listing__item-description">
          <span>{submission.issueDescription}</span>
        </div>
        <div className="submission-listing__item-footer input-wrapper">
          <Stack direction="horizontal" gap={1} className="submission-created-at">
            <span className="calendar-icon" aria-hidden="true" />
            <span>Submitted {submission.createdAt}</span>
          </Stack>
          {submission.location && (
            <Stack direction="horizontal" gap={1}>
              <span className="map-icon" aria-hidden="true" />
              <span>{submission.location}</span>
            </Stack>
          )}
        </div>
      </Link>
    </li>
  );
}
